export enum AdditionalSettingType {
    setup = "setup",
    other = "other",
    id = "id",
    outbound = "outbound"
}